import { v4 } from 'uuid';
import { modalsActionCreator } from '../../events/modals';

const { add } = modalsActionCreator;

const addModal = (ModalComponent, props = {}) => dispatch =>
  dispatch(add({ id: v4(), ModalComponent, props }));

export default addModal;
